<template>
  <div class="modal contact-modal ready-modal">
    <div class="overlay" @click="closeReadyModal"></div>
    <div class="wrapper">
      <img class="close" @click="closeReadyModal" src="./../img/close.svg" />
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields" v-if="!successMessage">
              <div class="title">{{ $t(`Are you sure?`) }}</div>
              <div class="price title">TOTAL: {{ modifiedPrice }} {{ internalCurrencyName }}</div>
              <button :disabled="buyProductLoading" :class="{'loading': buyProductLoading}" class="button" @click="buy">
                <span class="text">{{ $t(`Buy`) }}</span>
                <span class="spinner"></span>
              </button>
              <transition name="fade">
                <div class="desc error-desc red" v-if="error">{{ error }}</div>
              </transition>
            </div>
            <transition name="fade">
              <div class="form-fields" v-if="successMessage">
                <div class="title error-desc green message">{{ successMessage }}</div>
                <button class="button" @click="closeReadyModal">
                  <span>{{ $t(`Ok`) }}</span>
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ReadyModal',
  props: [],
  inject: ['itemType', 'buyProduct', 'buyPack', 'buyProductLoading', 'closeReadyModal', 'successMessage', 'error', 'internalCurrencyName', 'readyProduct', 'readyPromt', 'activePack', 'readyPack', 'productPageItem', 'productPageType'],
  components: {
  },

  data: function () {
    return {
      activePack: '',
      modifiedPrice: ''
    }
  },

  mounted() {
    if (this.readyProduct) {
      if (this.readyPromt) {
        this.modifiedPrice = this.readyProduct.price;
      } else if (this.readyPack) {
        this.modifiedPrice = this.activePack.price;
      }
    } else {
      if (this.readyPromt) {
        this.modifiedPrice = this.productPageItem.price;
      } else if (this.readyPack) {
        this.modifiedPrice = this.activePack.price;
      }
    }
    this.getActivePack();
  },

  methods: {
    getActivePack() {
      if (this.readyPack || (this.productPageItem && this.productPageType === 'pack')) {
        // Pack page
        console.log('pack page');
        const packId = this.readyProduct?.id || this.productPageItem.id;
        this.$http.get( 'packs/' + packId + '/info')
          .then((res) => {
            this.activePack = res.data.payload;
            this.modifiedPrice = res.data.payload.price;
          })
          .catch((error) => {
            console.error('Error fetching pack info:', error);
          });
      } else {
        // Prompt page
        console.log('prompt page');
        const promptId = this.readyProduct?.id || this.productPageItem.id;
        this.$http.get( 'products/' + promptId + '/info')
          .then((res) => {
            this.modifiedPrice = res.data.payload.price;
          })
          .catch((error) => {
            console.error('Error fetching product info:', error);
          });
      }
    },
    buy() {
      if (this.itemType === 'prompt') {
        this.buyProduct();
        console.log('Buy prompt')
      } else if (this.itemType === 'pack') {
        this.buyPack();
        console.log('Buy pack')
      }

      console.log('Buy product', this.itemType);
    }
  },
});
</script>

<style scoped>
.ready-modal .message {
  white-space: pre-line;
}
</style>


